<div class="snackbar-wrapper">
  <mat-icon class="snackbar-icon">{{ getIcon(data.type) }}</mat-icon>
  <span class="snackbar-message">{{ data.message }}</span>
  <button
    mat-icon-button
    class="snackbar-close"
    (click)="data.ref.dismiss()"
    aria-label="Close"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
